var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useContext, useEffect, useState } from 'react';
import NodeTitle from './NodeTitle';
import { ZdsDivider } from '@zig-design-system/ui-components-react';
import ApiService from '../services/ApiService';
import SubnodeContent from './SubnodeContent';
import Alert, { AlertType } from '../../Shared/components/Alert';
import { RootContext } from '../../Context/RootContext';
const Node = ({ startNodeId, showTitle = true, level = 0, subnodesAreLinks = false }) => {
    var _a;
    const [node, setNode] = useState(null);
    const [error, setError] = useState(undefined);
    const rootContext = useContext(RootContext);
    const apiService = new ApiService(rootContext);
    useEffect(() => {
        setError(null);
        if (startNodeId != (node === null || node === void 0 ? void 0 : node.uid)) {
            const getNodes = () => __awaiter(void 0, void 0, void 0, function* () {
                const node = yield apiService.getNode(startNodeId);
                if (!node || node.length === 0) {
                    setError('Could not fetch node with id ' + startNodeId);
                }
                setNode(node);
            });
            getNodes();
        }
    }, [startNodeId]);
    useEffect(() => {
        if (!node) {
            return;
        }
        apiService.logNodeView(node.uid);
        document.dispatchEvent(new Event('kb:content:loaded'));
    }, [node]);
    if (error) {
        return React.createElement(Alert, { message: error, type: AlertType.error });
    }
    const shouldShowMainContent = (node) => {
        if (parseInt(rootContext.pluginContext.hideMenuStartNode)) {
            // Only hide if there are subnodes and we are still at the startNodeUid level.
            if ((node === null || node === void 0 ? void 0 : node.subnodes.length) > 0 && level === 0) {
                return false;
            }
        }
        return true;
    };
    return (React.createElement("div", { className: "zds-row" },
        React.createElement("div", { className: "no-indentation default-content" },
            shouldShowMainContent(node) && (React.createElement(React.Fragment, null,
                showTitle && React.createElement(NodeTitle, { node: node }),
                React.createElement("div", { className: "knowledgeBase-content-wrap", dangerouslySetInnerHTML: { __html: node === null || node === void 0 ? void 0 : node.content[0].html } }))),
            !Boolean(parseInt(rootContext.pluginContext.hideMenuSubNodes)) && (React.createElement(React.Fragment, null, (_a = node === null || node === void 0 ? void 0 : node.subnodes) === null || _a === void 0 ? void 0 : _a.map((subnode, index) => (React.createElement(React.Fragment, { key: subnode.uid + '-' + index + '-' + Math.floor(Math.random() * 100000) },
                React.createElement(SubnodeContent, { subnode: subnode, asLink: subnodesAreLinks }),
                node.subnodes.length - 1 != index && React.createElement(ZdsDivider, { className: "zds-margin-y-0 " })))))))));
};
export default Node;
